export function retiraVerificadores(cod:string){
    const aux_vet = cod.split("");
    aux_vet.splice(11, 1);
      aux_vet.splice(22, 1);
      aux_vet.splice(33, 1);
      aux_vet.splice(44, 1);
      let cod_string = aux_vet.toString();
      for (let index = 0; index < cod_string.length; index++) {
        cod_string = cod_string.replace(",", "");
      }
      cod = cod_string.toString();
      return cod;
}